// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"231":"5b26fc1c","664":"04b555b6","766":"6848039e","768":"1c061251","980":"cf557af5"}[chunkId] + ".css";
};